import { Templates } from "./Templates";

/**Revenue Price Dialogs */
export class RevenuePriceDialogs
{
	constructor() { }

	/**Initialize dialog for the pricing chart and details */
	public InitializeReveneuPriceGraphDialog()
	{
		let instance = $('#' + Templates.Ids.revenuePriceGraph).dxPopup({
			title: "",
			maxWidth: 900,
			height: "98%",
			contentTemplate: '<div id="chartModalDialog">' + Templates.ChartModalTemplate() + '</div>',
			showCloseButton: false,
			// this option is rather important as it allows us to access the divs, etc in the content template before the popup is opened
			deferRendering: false,
			toolbarItems: [{
				// Custom close button with our font icon
				template: () =>
				{
					return $("<button><i class =\"fonticon-close-window\"></i></button>").dxButton({
						onClick: () =>
						{
							instance.hide();
						},
						hoverStateEnabled: false
					})
				},
				location: "after"
			}],
			closeOnOutsideClick: false,
			showTitle: true,
			visible: false,
			dragEnabled: false,
			shading: true,
			shadingColor: "rgba(0, 0, 0, 0.5)",

			// By default turn off animations
			animation: {
				show: {
					duration: 0,
					type: "pop"
				},
				hide: {
					duration: 0,
					type: "pop"
				}
			}
		}).dxPopup("instance");

		$('#chartModalDialog').dxScrollView({
			height: "100%",
			width: '100%',
			direction: 'vertical'
		});
	}

	/**Initialize unsupported state dialog  */
	public InitializeUnsupportedStateDialog()
	{
		window.NauUtility.Dx.dialogUtility.searchDialog({
			dialogId: Templates.Ids.unsupportedStatePopup,
			title: "Unsupported State Selection",
			contentTemplate: Templates.UnsupportedStateModalTemplate()
		});
	}
}